import dayjs from 'dayjs';

import { I18n } from 'react-redux-i18n-lite';

import { REDUCER } from '../reducers/reducersConst';
import * as drawerActions from '../actions/drawerActions';
import * as messageAlert from './messageAlertAction';
import { getLogger } from '../services/logger';
import { createDiscussion } from '../services/api/discussionApi';
import { updateDiscussionsLists, updateDiscussion } from '../actions/discussionActions';
import * as analyticsApi from '../services/api/analyticsApi';
import { ANALYTICS_CONTEXT, ANALYTICS_EVENT } from '../types/analytics';

import { GROUPS, ROLE } from '../const';
import { MODES } from '../components/drawer-contents/AssignmentsContentPanel/assignmentsContentPanelService';

const debug = getLogger('actions:assignmentsDrawerActions');

export let setDiscussionId = discussionId => {
  return {
    type: REDUCER.DISCUSSION_DRAWER.SET_DISCUSSION_ID,
    discussionId
  };
};

export let setStartDate = (startDate = dayjs()) => {
  return {
    type: REDUCER.DISCUSSION_DRAWER.SET_START_DATE,
    startDate
  };
};

export let setDueDate = (dueDate = dayjs().add(3, 'days')) => {
  return {
    type: REDUCER.DISCUSSION_DRAWER.SET_DEAD_LINE,
    dueDate
  };
};

export let setSelectedGroup = (selectedGroup = GROUPS.EVERYONE) => {
  return {
    type: REDUCER.DISCUSSION_DRAWER.SET_SELECTED_GROUP,
    selectedGroup
  };
};

export let setDescription = (description = '') => {
  return {
    type: REDUCER.DISCUSSION_DRAWER.SET_DESCRIPTION,
    description
  };
};

export let setTitle = (title = '') => {
  return {
    type: REDUCER.DISCUSSION_DRAWER.SET_TITLE,
    title
  };
};

export let setMode = (mode = MODES.READ) => {
  return {
    type: REDUCER.DISCUSSION_DRAWER.SET_MODE,
    mode
  };
};

export let createNewDiscussion = () => {
  return (dispatch, getState) => {
    const discussionObject = createDiscussionObject(getState());
    let newDiscussion = discussionObject;
    newDiscussion.description = discussionObject.description.replace(/(<([^>]+)>)/gi, '');
    newDiscussion.title = discussionObject.title.replace(/(<([^>]+)>)/gi, '');

    const startedAt = Date.now();
    createDiscussion(newDiscussion)
      .then(res => {
        dispatch(updateDiscussionsLists());
        dispatch(drawerActions.setDrawerClosed());
        dispatch(messageAlert.info(`${I18n.t('discussions.messageAlert.discussionCreated')}`));
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.CREATE_DISCUSSION,
          classId: newDiscussion.sectionId,
          context: ANALYTICS_CONTEXT.DISCUSSION_DRAWER,
          status: 'success',
          durationMs: Date.now() - startedAt
        });
        return res.data;
      })
      .catch(error => {
        debug.error('[createNewDiscussion] %s', error);
        dispatch(messageAlert.error(`${I18n.t('discussions.error.discussionCreation')}`));
        analyticsApi.trackAnalyticsEvent({
          event: ANALYTICS_EVENT.CREATE_DISCUSSION,
          classId: newDiscussion.sectionId,
          context: ANALYTICS_CONTEXT.DISCUSSION_DRAWER,
          status: 'error',
          durationMs: Date.now() - startedAt,
          errorMessage: error && error.message
        });
      });
  };
};

export let editDiscussion = discussion => {
  return dispatch => {
    return dispatch(updateDiscussion(discussion, discussion.discussionId));
  };
};

// Aux functions

const createDiscussionObject = currentStore => {
  const user = currentStore.account.user;
  const classroom = currentStore.classrooms.selectedClassroom.classroom;
  const students = currentStore.classrooms.selectedClassroom.participants.filter(
    participant => participant.role === ROLE.STUDENT
  );
  const studentsGroups = currentStore.classrooms.selectedClassroom.groups;
  const discussion = currentStore.discussionsDrawer;
  const { id, isEveryone, isGroup } = discussion.selectedGroup;

  const users = isEveryone
    ? students.map(student => student._id)
    : isGroup
    ? studentsGroups.filter(group => group.id === id)[0].participants
    : id;

  return {
    author: {
      id: user._id,
      name: user.name,
      surname: user.surname,
      role: user.role,
      picture: user.picture
    },
    description: discussion.description,
    dueDate: discussion.dueDate,
    sectionId: classroom.id,
    startDate: discussion.startDate,
    title: discussion.title,
    users: users
  };
};
